import { useState } from 'react';

import { API } from 'api';
import { apiBasePath, apiName } from 'assets/constants';
import type { OverlayQuestionProps } from './types';
import { showOverlaySubmitErrorToast } from './toast';
import { DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { ButtonSizes, Typography } from '@repo/ui';
import { Button, ButtonColors, ButtonVariants } from 'components';

import styles from '../AudienceFeedbackOverlay.module.scss';

const NpsTextQuestion = ({
  kitId,
  feedbackType,
  onDone,
}: OverlayQuestionProps) => {
  const [text, setText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    if (isSubmitting) return;

    const trimmedText = text.trim();
    if (!trimmedText) {
      onDone();
      return;
    }

    setIsSubmitting(true);
    try {
      await API.post(
        apiName,
        `${apiBasePath}/nps/${kitId}`,
        {
          feedback: trimmedText,
          source: 'overlay',
        },
        true,
        undefined,
        {
          tags: {
            domain: DOMAINS.FEEDBACK,
            importance: IMPORTANCE.MEDIUM,
          },
          context: {
            kitId,
            component: 'NpsTextQuestion',
            feedbackType,
            source: 'overlay',
          },
        },
      );
    } catch (err) {
      console.error('Failed to submit AudienceFeedback/NpsTextQuestion', err);
      showOverlaySubmitErrorToast();
    } finally {
      setIsSubmitting(false);
    }

    onDone();
  };

  return (
    <div className={styles.content}>
      <Typography variant='body-m' className={styles.primaryText}>
        {'Any other feedback?'}
      </Typography>

      <div className={styles.inputRow}>
        <textarea
          className={styles.textarea}
          rows={3}
          value={text}
          onChange={e => setText(e.target.value)}
          aria-label='Any other feedback?'
        />
      </div>

      <Typography variant='label' className={styles.tertiaryText}>
        Prefer to chat with the Product Team?{' '}
        <a
          href={'https://calendly.com/tanner-tinyhealth/30min'}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.link}
        >
          Schedule a call
        </a>
      </Typography>

      <div className={styles.actionsRow}>
        <Button
          label='Submit'
          onClick={onSubmit}
          loading={isSubmitting}
          variant={ButtonVariants.SOLID}
          color={ButtonColors.GREEN}
          size={ButtonSizes.S}
        />
      </div>
    </div>
  );
};

export default NpsTextQuestion;
